define('TescoMobile_DataLayer/js/datalayer-extra-trigger-actions',['jquery', 'underscore'], function ($, _) {
  'use strict';

  return {
    addTrigger: function (triggerAction) {
      var self = this;
      $(document).one(triggerAction.action, triggerAction.element, triggerAction, function (onEvent) {
        self.triggerEvent(onEvent.data);
        if (!(triggerAction !== null && triggerAction !== void 0 && triggerAction.once)) {
          self.addTrigger(triggerAction);
        }
      });
    },
    triggerEvent: function (triggerAction) {
      var self = this;
      _.each(triggerAction.dataActions, function (dataAction) {
        self.processDataAction(dataAction);
      });
    },
    processDataAction: function (dataAction) {
      switch (dataAction.type) {
        case 'setBodyNewProductOnlyMode':
          $.data(document.body, 'nextEventNewProductsOnlyMode', true);
          break;
        case 'setAvoidNextDlEventMode':
          $.data(document.body, 'avoidNextDlEventMode', dataAction.event);
          break;
        case 'eventJson':
          $.data(document.body, 'setEventJsonData', dataAction.data);
          break;
        case 'triggerAction':
          $(dataAction.element).trigger(dataAction.action);
          break;
        case 'document.body.data':
          $.data(document.body, dataAction.key, dataAction.value);
          break;
        case 'document.data.hitsUpdated.json':
          var dataArray = this.getHitsUpdatedProperty(dataAction.property),
            dataJson = JSON.stringify(dataArray);
          $.data(document.body, dataAction.key, dataJson);
          break;
      }
    },
    getHitsUpdatedProperty: function (property) {
      var propertyArray = [];
      if (window.hitsUpdated && Object !== null && Object !== void 0 && Object.keys(window.hitsUpdated).length) {
        _.each(window.hitsUpdated, function (hit) {
          if (!!hit[property]) {
            propertyArray.push(hit[property]);
          }
        });
      }
      return propertyArray;
    }
  };
});

